/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, PopoverController } from '@ionic/angular';
import * as moment from 'moment';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-time-select',
  templateUrl: './time-select.page.html',
  styleUrls: ['./time-select.page.scss']
})
export class TimeSelectPage implements OnInit {
  activePerson: any = {};
  stopIdx: number;
  field: string;
  times: any = [];
  notEnoughTime = false;
  hrs = 0;
  mins = 0;
  timeMoment: any;
  timeDisplay = '';
  minMoment;
  maxMoment;
  minTimeDisplay = '';
  maxTimeDisplay = '';
  minHrs: number;
  minMins: number;
  maxHrs: number;
  maxMins: number;
  errorTooEarly = false;
  errorTooLate = false;
  prompt = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    private logger: LoggerService
  ) {}

  formatTimes() {
    const time = moment(this.activePerson.ymd, 'YYYYMMDD');
    const isNextDay = this.hrs >= 24;

    time.add(this.hrs, 'hours');
    time.add(this.mins, 'minutes');

    this.timeMoment = time;
    this.errorTooEarly = this.timeMoment.isSameOrBefore(this.minMoment);
    this.errorTooLate = this.timeMoment.isSameOrAfter(this.maxMoment);
    this.timeDisplay = isNextDay ? time.format('LL') : time.format('LT');
  }

  setMinMaxTimes() {
    const idx = this.stopIdx;
    const stops = this.activePerson.stops;
    const field = this.field;
    const ymdMoment = moment(this.activePerson.ymd, 'YYYYMMDD');
    const minTimeSecs = moment(this.activePerson.ymd, 'YYYYMMDD').add(2, 'hours').add(59, 'minutes').unix();
    const maxTimeSecs = moment(this.activePerson.ymd, 'YYYYMMDD').add(27, 'hours').unix();

    const getMinSecs = () => {
      let counter = 0;
      if (field === 'FROM') {
        for (let i = idx - 1; i >= 0; i--) {
          if (stops[i].out.time != null) {
            return stops[i].out.time.secs;
          }
          if (stops[i].in.time != null) {
            return stops[i].in.time.secs;
          }
        }
      }
      if (field === 'TO') {
        for (let i = idx; i >= 0; i--) {
          if (counter !== 0 && stops[i].out.time != null) {
            return stops[i].out.time.secs;
          }
          if (stops[i].in.time != null) {
            return stops[i].in.time.secs;
          }
          counter++;
        }
      }

      return minTimeSecs;
    };

    const getMaxSecs = () => {
      let counter = 0;
      if (field === 'FROM') {
        for (let i = idx; i < stops.length; i++) {
          // don't use arrive time current stop
          if (counter !== 0 && stops[i].in.time != null) {
            return stops[i].in.time.secs;
          }
          if (stops[i].out.time != null) {
            return stops[i].out.time.secs;
          }
          counter++;
        }
      }
      if (field === 'TO') {
        for (let i = idx + 1; i < stops.length; i++) {
          if (stops[i].in.time != null) {
            return stops[i].in.time.secs;
          }
          if (stops[i].out.time != null) {
            return stops[i].out.time.secs;
          }
        }
      }

      return maxTimeSecs;
    };

    // get min/max seconds
    const minSecs = getMinSecs();
    const maxSecs = getMaxSecs();

    // get min/max moments
    this.minMoment = moment(minSecs, 'X');
    this.maxMoment = moment(maxSecs, 'X');

    // get min/max hours
    this.minHrs = this.minMoment.hour();
    this.maxHrs = this.maxMoment.hour();

    // if max time is the next day, max hrs need to be b/w 24 and 27
    if (this.minMoment.isSame(this.maxMoment, 'day') === false) {
      this.maxHrs = this.maxHrs + 24;
    }

    // get min/max minutes
    this.minMins = this.minMoment.minute();
    this.maxMins = this.maxMoment.minute();

    this.minTimeDisplay = this.minMoment.isSame(ymdMoment, 'day') ? this.minMoment.format('LT') : this.minMoment.format('LL');
    this.maxTimeDisplay = this.maxMoment.isSame(ymdMoment, 'day') ? this.maxMoment.format('LT') : this.maxMoment.format('LL');
  }

  setTimesOnLoad() {
    const myStop = this.activePerson.stops[this.stopIdx];
    const myTime = this.field === 'FROM' ? myStop.in.time : myStop.out.time;

    if (myTime == null || myTime.secs == null) {
      const time = this.minMoment.clone().add(1, 'minute');
      this.hrs = time.hour();
      this.mins = time.minute();
    } else {
      const myMoment = moment(myTime.secs, 'X');
      const isNextDay = myMoment.isSame(moment(this.activePerson.ymd, 'YYYYMMDD'), 'day') === false;
      this.hrs = isNextDay ? myMoment.hour() + 24 : myMoment.hour();
      this.mins = myMoment.minute();
    }

    this.formatTimes();
  }

  onSubmit() {
    const x = moment(this.activePerson.ymd, 'YYYYMMDD');
    const y = this.timeMoment;
    const mins = moment.duration(y.diff(x)).asMinutes();

    this.popoverCtrl.dismiss({
      mins,
      display: this.timeDisplay,
      secs: this.timeMoment.unix()
    });
  }

  dismiss() {
    this.popoverCtrl.dismiss();
  }

  init() {
    this.activePerson = this.navParams.data.activePerson;
    this.stopIdx = this.navParams.data.stopIdx;
    this.field = this.navParams.data.field;

    this.setMinMaxTimes();
    this.setTimesOnLoad();

    this.prompt = this.field === 'FROM' ? 'Arrived:' : 'Departed:';
    this.prompt += ' ' + this.activePerson.stops[this.stopIdx].label;
  }

  ionViewDidEnter() {
    // let selectedTime = null;
    // if(this.field =="FROM") {
    //     selectedTime = this.activePerson.stops[this.stopIdx].in.time;
    // }
    // if(this.field =="TO") {
    //     selectedTime = this.activePerson.stops[this.stopIdx].out.time;
    // }
    // setTimeout(() => {
    //     if(selectedTime){
    //         let availableTimes = document.querySelectorAll('ion-item.in-list:not(.item-label)');
    //         let timeElem: Element | null = null;
    //         availableTimes.forEach(function(el) {
    //             if (el.innerHTML.indexOf(selectedTime.display) !== -1) {
    //                 timeElem = el;
    //             }
    //         });
    //      if(timeElem){
    //          timeElem.scrollIntoView({ block: 'center'});
    //      }
    //     }
    //    // defaultElem = document.querySelector('[default="true"]');
    //     //defaultElem.scrollIntoView({ block: 'center' });
    // }, 250);
  }

  ionViewWillLoad() {}

  ngOnInit() {
    this.init();
  }
}

// getTimes() {
//     let processing;
//     let idx = this.stopIdx;
//     let field = this.field;
//     let nextDay = moment(this.activePerson.ymd, 'YYYYMMDD').add(1, 'day').format('ll');

//     let x = 5;              // minutes interval
//     let times = [];         // time array
//     let tt = 0;
//     let ap = ['AM', 'PM', 'AM (' + nextDay + ')'];  // AM-PM

//     let stops = this.activePerson.stops;
//     let minMinutes, maxMinutes;

//     if (processing === true) return;
//     processing = true;

//     // arrival time is from previous known time + 5 to the next known time - 5

//     let getMin = () => {
//         let counter = 0;
//         if (field === 'FROM') {
//             for (let i = idx - 1; i >= 0; i--) {
//                 if (stops[i].out.time != null) {
//                     return stops[i].out.time.mins;
//                 }
//                 if (stops[i].in.time != null) {
//                     return stops[i].in.time.mins;
//                 }
//             }
//         }
//         if (field === 'TO') {
//             for (let i = idx; i >= 0; i--) {
//                 if (counter !== 0 && stops[i].out.time != null) {
//                     return stops[i].out.time.mins;
//                 }
//                 if (stops[i].in.time != null) {
//                     return stops[i].in.time.mins;
//                 }
//                 counter++;
//             }
//         }

//         return 180;
//     }

//     let getMax = () => {
//         let counter = 0;
//         if (field === 'FROM') {
//             for (let i = idx; i < stops.length; i++) {
//                 // don't use arrive time current stop
//                 if (counter !== 0 && stops[i].in.time != null) {
//                     return stops[i].in.time.mins;
//                 }
//                 if (stops[i].out.time != null) {
//                     return stops[i].out.time.mins;
//                 }
//                 counter++;
//             }
//         }
//         if (field === 'TO') {
//             for (let i = idx + 1; i < stops.length; i++) {
//                 if (stops[i].in.time != null) {
//                     return stops[i].in.time.mins;
//                 }
//                 if (stops[i].out.time != null) {
//                     return stops[i].out.time.mins;
//                 }
//             }
//         }

//         return 1620;
//     }

//     minMinutes = Math.max(180, getMin());
//     maxMinutes = Math.min(1620, getMax());

//     if (maxMinutes < minMinutes) {
//         this.notEnoughTime = true;
//         return;
//     }

//     tt = minMinutes;

//     // this.logger.log(idx, field, 'min', minDisplay, 'max', maxDisplay)
//     this.logger.log('min minutes', minMinutes, 'max minutes', maxMinutes);

//     //loop to increment the time and push results in array
//     for (let i = 0; tt <= maxMinutes; i++) {
//         let hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
//         let mm = (tt % 60); // getting minutes of the hour in 0-55 format
//         // times[i] = ("" + ((hh == 0 || hh == 12) ? 12 : hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ' ' + ap[Math.floor(hh/12)];
//         // if ()
//         // if (hh > 24) {
//         //     console.log('hh');
//         // }
//         times[i] = {
//             mins: tt,
//             display: ("" + ((hh == 0 || hh == 12 || hh == 24) ? 12 : hh % 12)).slice(-2) + ':' + ("0" + mm).slice(-2) + ' ' + ap[Math.floor(hh / 12)]
//         };
//         tt = tt + x;
//     }

//     processing = false;
//     return times;
// }

// onClickTime(time) {
//     this.logger.log('time', time)
//     this.popoverCtrl.dismiss(time);
// }
